import React from 'react';

type SciFinderAuthContextValue = {
  accessToken: string | null;
  isAuthenticating: boolean;
  authenticate: () => Promise<void>;
};

export const SciFinderAuthContext = React.createContext<SciFinderAuthContextValue>({
  accessToken: null,
  isAuthenticating: false,
  authenticate: async () => {
    // do nothing
  },
});
